import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onChange", "rules", "id", "control", "hasLeftPadding", "borderless", "twStyle", "inputStyle", "wrapperStyle", "testId", "isError", "supportText", "supportTextStyles", "isFullwidth", "label", "secondaryLabel", "supportTextVariant", "iconStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import * as React from 'react';
import { useCallback } from 'react';
import { Controller } from 'react-hook-form';
import { TextInput as FlowBiteTextInput } from 'flowbite-react';
import { borderColorObject } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var TextInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var onChange = props.onChange,
      _props$rules = props.rules,
      rules = _props$rules === void 0 ? {} : _props$rules,
      id = props.id,
      control = props.control,
      _props$hasLeftPadding = props.hasLeftPadding,
      hasLeftPadding = _props$hasLeftPadding === void 0 ? false : _props$hasLeftPadding,
      borderless = props.borderless,
      twStyle = props.twStyle,
      inputStyle = props.inputStyle,
      wrapperStyle = props.wrapperStyle,
      testId = props.testId,
      isError = props.isError,
      supportText = props.supportText,
      supportTextStyles = props.supportTextStyles,
      isFullwidth = props.isFullwidth,
      label = props.label,
      secondaryLabel = props.secondaryLabel,
      _props$supportTextVar = props.supportTextVariant,
      supportTextVariant = _props$supportTextVar === void 0 ? 'default' : _props$supportTextVar,
      iconStyle = props.iconStyle,
      rest = _objectWithoutProperties(props, _excluded);

  var handleChange = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (onChange) onChange(e.target.value);
    return e;
  }, [onChange]);
  var supportTextEl = React.useMemo(function () {
    return supportText ? /*#__PURE__*/_jsx(StyledSupportText, {
      $isError: isError,
      supportTextStyles: supportTextStyles,
      variant: supportTextVariant,
      children: supportText
    }) : null;
  }, [isError, supportText, supportTextStyles, supportTextVariant]);
  var labelEl = React.useMemo(function () {
    return label ? /*#__PURE__*/_jsxs(StyledLabel, {
      htmlFor: id,
      fullwidth: isFullwidth,
      children: [/*#__PURE__*/_jsx("span", {
        children: label
      }), /*#__PURE__*/_jsx(_StyledSpan, {
        children: secondaryLabel || ''
      })]
    }) : null;
  }, [isFullwidth, id, label, secondaryLabel]);
  if (control) return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledWrapper, {
      $isFullWidth: isFullwidth,
      children: [labelEl, /*#__PURE__*/_jsx(Controller, {
        name: id,
        control: control,
        rules: rules,
        render: function render(_ref) {
          var field = _ref.field;
          return /*#__PURE__*/_jsx(TextInputStyled, _objectSpread(_objectSpread(_objectSpread({
            hasleftpadding: hasLeftPadding ? '1' : '0',
            borderless: borderless ? '1' : '0',
            twstyle: twStyle,
            wrapperstyle: wrapperStyle,
            inputstyle: inputStyle,
            "data-cy": testId,
            $isError: isError,
            $isFullwidth: isFullwidth,
            $iconStyle: iconStyle
          }, field), rest), {}, {
            ref: ref
          }));
        }
      })]
    }), supportTextEl]
  });
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    $isFullWidth: isFullwidth,
    children: [labelEl, /*#__PURE__*/_jsx(TextInputStyled, _objectSpread(_objectSpread({
      onChange: handleChange,
      hasleftpadding: hasLeftPadding ? '1' : '0',
      borderless: borderless ? '1' : '0',
      twstyle: twStyle,
      wrapperstyle: wrapperStyle,
      inputstyle: inputStyle,
      "data-cy": testId,
      $isError: isError,
      $isFullwidth: isFullwidth,
      $iconStyle: iconStyle
    }, rest), {}, {
      ref: ref
    })), supportTextEl]
  });
});
TextInput.displayName = 'TextInput';
export default TextInput;

var TextInputStyled = /*#__PURE__*/_styled(FlowBiteTextInput).withConfig({
  displayName: "text-input__TextInputStyled",
  componentId: "sc-18xq43t-0"
})(["", " ", " svg{", "}.absolute.inset-y-0.left-0 svg{", "}.absolute.inset-y-0.right-0 svg{", "}input{", " ", " ", " ", " ", " ", " ", " ", " ", " ", "}", " ", ""], {
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem"
}, function (_ref2) {
  var $isFullwidth = _ref2.$isFullwidth;
  return $isFullwidth ? {
    "width": "100%"
  } : {};
}, {
  "height": "20px",
  "width": "20px",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
}, function (_ref3) {
  var $iconStyle = _ref3.$iconStyle;
  return $iconStyle || {};
}, function (_ref4) {
  var rightIconStyle = _ref4.rightIconStyle;
  return rightIconStyle || {};
}, {
  "height": "3rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "fontSize": "1rem !important",
  "lineHeight": "1.5rem !important",
  "::placeholder": {
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1 !important",
    "color": "rgb(102 102 118 / var(--tw-text-opacity)) !important"
  },
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
  },
  ":focus": {
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
    "outlineWidth": "0px",
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
  },
  ":disabled": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
  }
}, function (_ref5) {
  var icon = _ref5.icon;
  return icon ? {
    "paddingLeft": "2.5rem"
  } : {};
}, function (_ref6) {
  var rightIcon = _ref6.rightIcon;
  return rightIcon ? {
    "paddingRight": "2.5rem"
  } : {};
}, function (_ref7) {
  var color = _ref7.color;
  return color === 'failure' ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(204 0 34 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity))"
  } : {};
}, function (_ref8) {
  var $isFullwidth = _ref8.$isFullwidth;
  return $isFullwidth ? {
    "width": "100%"
  } : {};
}, function (_ref9) {
  var borderless = _ref9.borderless;
  return borderless === '1' ? {
    "borderWidth": "0px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    ":focus-visible": {
      "borderWidth": "0px",
      "outlineWidth": "0px",
      "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
      "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
      "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
    }
  } : {};
}, function (_ref10) {
  var bordercolor = _ref10.bordercolor;
  return bordercolor ? borderColorObject[bordercolor] : {};
}, function (_ref11) {
  var hasleftpadding = _ref11.hasleftpadding;
  return hasleftpadding === '1' ? {
    "paddingLeft": "2.5rem"
  } : {};
}, function (_ref12) {
  var $isError = _ref12.$isError;
  return $isError ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(204 0 34 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1 !important",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity)) !important",
    "--tw-text-opacity": "1",
    "color": "rgb(145 0 24 / var(--tw-text-opacity))",
    "::placeholder": {
      "--tw-text-opacity": "1 !important",
      "color": "rgb(145 0 24 / var(--tw-text-opacity)) !important"
    }
  } : {};
}, function (_ref13) {
  var inputstyle = _ref13.inputstyle;
  return inputstyle;
}, function (_ref14) {
  var wrapperstyle = _ref14.wrapperstyle;
  return wrapperstyle;
}, function (_ref15) {
  var twstyle = _ref15.twstyle;
  return twstyle;
});

var StyledSupportText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "text-input__StyledSupportText",
  componentId: "sc-18xq43t-1"
})(function (_ref16) {
  var supportTextStyles = _ref16.supportTextStyles,
      $isError = _ref16.$isError,
      variant = _ref16.variant;
  return [{
    "marginTop": "0.5rem",
    "fontSize": "0.875rem !important",
    "lineHeight": "1.25rem !important",
    "fontWeight": "400"
  }, variant === 'success' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(0 119 64 / var(--tw-text-opacity))"
  } : variant === 'error' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(204 0 34 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  }, $isError ? {
    "--tw-text-opacity": "1",
    "color": "rgb(204 0 34 / var(--tw-text-opacity))"
  } : {}].concat(_toConsumableArray(supportTextStyles || []));
});

var StyledLabel = /*#__PURE__*/_styled.label.withConfig({
  displayName: "text-input__StyledLabel",
  componentId: "sc-18xq43t-2"
})(["", " ", ""], {
  "marginBottom": "0.5rem",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
}, function (_ref17) {
  var fullwidth = _ref17.fullwidth;
  return fullwidth ? {
    "width": "100%"
  } : {};
});

var StyledWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "text-input__StyledWrapper",
  componentId: "sc-18xq43t-3"
})(["", " ", ""], {
  "position": "relative"
}, function (_ref18) {
  var $isFullWidth = _ref18.$isFullWidth;
  return $isFullWidth ? {
    "width": "100%"
  } : {
    "width": "320px"
  };
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "text-input___StyledSpan",
  componentId: "sc-18xq43t-4"
})({
  "fontSize": "0.875rem !important",
  "lineHeight": "1.25rem !important",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(117 117 131 / var(--tw-text-opacity))"
});